import React from "react";
import { usePageErrorBoundaryHook } from "./error-boundary-hooks";

type PageContextErrorBoundary = ReturnType<typeof usePageErrorBoundaryHook>;
export const ErrorBoundaryContext =
  React.createContext<PageContextErrorBoundary | null>(null);

export function usePageContextErrorBoundary() {
  const context = React.useContext(ErrorBoundaryContext);

  if (!context) {
    throw new Error(
      "usePageContextErrorBoundary must be used within a PageContextErrorBoundaryProvider",
    );
  }

  return context;
}
